import { render, staticRenderFns } from "./areaMap.vue?vue&type=template&id=706ff603&scoped=true"
import script from "./areaMap.vue?vue&type=script&lang=js"
export * from "./areaMap.vue?vue&type=script&lang=js"
import style0 from "./areaMap.vue?vue&type=style&index=0&id=706ff603&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ff603",
  null
  
)

export default component.exports